import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  DefaultPaymentDetails,
  PatchPaymentSlip,
  Payee,
  PaymentSlip,
  PaymentSlipDetailsMeta,
  PaymentSlipPages,
  PaymentSlipPaymentDates,
  PaymentSlipPaymentDatesQuery,
  PaymentSlipPaymentType,
  PaymentSlipPutAction,
  PaymentSlipSearchQuery,
  PostPaymentSlip,
} from '@models/next/PaymentSlip';
import { z } from 'zod';

export const dashboardPaymentSlipApis = createApiHooks('/dashboard/payment-slip', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(PaymentSlipSearchQuery),
    response: PaymentSlipPages,
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: PaymentSlip,
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Query',
        name: 'action',
        schema: PaymentSlipPutAction.optional(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PostPaymentSlip,
      },
    ],
    response: PaymentSlip,
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PatchPaymentSlip,
      },
    ],
    response: PaymentSlip,
  },
  {
    method: 'put',
    path: '/:id',
    parameters: [
      {
        type: 'Query',
        name: 'action',
        schema: PaymentSlipPutAction,
      },
    ],
    response: PaymentSlip,
  },
  {
    method: 'get',
    path: '/payment-details-meta',
    parameters: [
      {
        type: 'Query',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: PaymentSlipDetailsMeta,
  },
  {
    method: 'get',
    path: '/default-payment-details',
    parameters: [
      {
        type: 'Query',
        name: 'payee_id',
        schema: z.number(),
      },
      {
        type: 'Query',
        name: 'payment_type',
        schema: PaymentSlipPaymentType,
      },
      {
        type: 'Query',
        name: 'd2d_no',
        schema: z.string(),
      },
      {
        type: 'Query',
        name: 'editing_id',
        schema: z.number().optional(),
      },
    ],
    response: DefaultPaymentDetails.array(),
  },
  {
    method: 'get',
    path: '/payee',
    response: Payee.array(),
  },
  {
    method: 'get',
    path: '/payment-dates',
    parameters: schemaToQueryParameters(PaymentSlipPaymentDatesQuery),
    response: PaymentSlipPaymentDates,
  },
]);
